import * as types from './types'

export const receiveModal = (value) => ({
  type: types.RECEIVE_MODAL,
  payload: value
})

export const resetModal = () => ({
  type: types.RESET_MODAL
})
